import type { AppRouteModule } from "/@/router/types";

import { LAYOUT } from "/@/router/constant";

const articleSync: AppRouteModule = {
  path: "/articleSync",
  name: "ArticleSync",
  component: LAYOUT,
  redirect: "/articleSync/index",
  meta: {
    hideChildrenInMenu: true,
    icon: "ant-design:partition-outlined",
    title: "文章多平台发布",
    orderNo: 6,
  },
  children: [
    {
      path: "index",
      name: "ArticleSyncIndex",
      component: () => import("/@/views/articleSync/index.vue"),
      meta: {
        title: "文章多平台发布",
        hideMenu: false,
      },
    },
  ],
};

export default articleSync;
